export const menuTypeMap = {
  1: "PC",
  2: "APP",
  4: "H5",
};
export const iconList = [
  "alert",
  "api",
  "appstore",
  "bell",
  "calendar",
  "carry-out",
  "check-square",
  "clock-circle",
  "code",
  "contacts",
  "dashboard",
  "control",
  "container",
  "database",
  "edit",
  "fund",
  "home",
  "idcard",
  "layout",
  "profile",
  "project",
  "pushpin",
  "read",
  "setting",
  "sliders",
  "tags",
  "tool",
  "wallet",
  "windows",
  "apartment",
  "block",
  "bars",
  "barcode",
  "codepen",
  "file-done",
  "history",
  "inbox",
  "line-chart",
  "link",
  "pull-request",
  "scan",
  "solution",
  "rise",
  "team",
  "user",
  "form",
  "dot-chart",
  "bar-chart",
  "pie-chart",
];

// 计划状态类型 1.待派发 2.待加工3.加工中4.暂停5.已关闭6.完工
export const planStatusMapColor = {
  1: "blue",
  2: "orange",
  3: "green",
  4: "red",
  6: "purple",
};

export const statusListColor = {
  1: "blue",
  2: "orange",
  3: "green",
  4: "red",
  6: "purple",
}

export const statusList = {
  1: 'page_plan_status_2',
  2: 'page_plan_status_3',
  3: 'page_plan_stop',
  4: 'page_plan_close',
  5: 'page_plan_finish',
}

// 计划状态类型 1.待派发 2.待加工3.加工中4.暂停5.已关闭6.完工
export const planStatusMap = {
  1: "page_plan_status_1",
  2: "page_plan_status_2",
  3: "page_plan_status_3",
  4: "page_plan_stop",
  6: "page_plan_status_6",
};

//工单状态 1：待加工，2：加工中，3：暂停，4：关闭,5:完工
export const orderStatusMap = {
  1: "page_plan_status_2",
  2: "page_plan_status_3",
  3: "page_plan_stop",
  4: "page_production_plan_close",
  5: "page_plan_status_6",
}

// 工序状态 1：待加工，2：加工中，5:完工
export const processStatusMap = {
  1: "page_plan_status_2",
  2: "page_plan_status_3",
  5: "page_plan_status_6",
}

// 工序状态 1：待加工，2：加工中，5:完工
export const processStatusMapColor = {
  1: "blue",
  2: "green",
  5: "purple",
}

// 生产计划类型 1 生产计划，2，来料计划
export const planCategoryMap = {
  1: "page_plan_production_plan",
  2: "page_plan_incoming_materials",
};

// 文件类型: 1:加工程序 2：工艺文件
export const fileTypeMap = {
  1: "page_my_document_program",
  2: "page_my_document_process",
};

// 支持预览的文件格式
export const canPreviewList = [
  "txt",
  "nc",
  "json",
  "jpg",
  "jpeg",
  "png",
  "svg",
  "gif",
  "bmp",
  "pdf",
  "mpf",
  "spf",
  "eia",
  "stp",
  "prg",
  "tap",
  "",
];

// 支持的预览的三大模式
export const previewMode = {
  text: ["txt", "nc", "json", "mpf", "spf", "eia", "stp", "prg", "tap", ""],
  image: ["jpg", "jpeg", "png", "svg", "gif", "bmp"],
  pdf: ["pdf"],
};

// 默认存在的路由地址
export const defaultRoutes = ['/printDevice', '/printCodeRules','/job/point','/ops/pdfPoint','/deLivery/point']

// 单据设置包含的菜单
export const billSettings = [
  "product",
  "setup_page_plan",
  "setup_plan_manage",
  "setup_plan_plan_hmi",
  "page_plan_production_plan",
  "page_job_plan_wip_analysis",
  "page_job_plan_personnel_performance_analysis",
  "page_job_plan_schedule",
  "page_job_plan_overdue_analysis",
  "page_job_plan_process_analysis",
  "page_job_plan_workstation_calendar",
]

export const menuProps = [
  {label: '常规菜单', value: 1},
  {label: '动态菜单', value: 2, checkedDynamic: true},
  {label: '全部菜单', value: 3, checkedDynamic: false},
]
